import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/app/(dach)/template.tsx");
